export default "__VITE_PUBLIC_ASSET__35fa5935__"